import React from "react";
import { Delete } from "lucide-react";

/**
 * Y2K-terminal style PIN pad.
 * Big tactile keys, lime hover/active states, square edges.
 */
export default function PinPad({ value, onChange, max = 4 }) {
  const press = (d) => {
    if (value.length >= max) return;
    onChange(value + d);
  };
  const back = () => onChange(value.slice(0, -1));

  const dots = Array.from({ length: max }).map((_, i) => {
    const filled = i < value.length;
    return (
      <div
        key={i}
        data-testid={`pin-dot-${i}`}
        className={`h-2.5 w-2.5 rounded-full transition-all duration-200 ${
          filled
            ? "bg-lime lime-glow scale-110"
            : "border border-border bg-transparent"
        }`}
      />
    );
  });

  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

  const keyClass =
    "h-16 sm:h-[68px] flex items-center justify-center text-2xl font-mono font-medium " +
    "bg-card text-foreground border border-border " +
    "hover:border-lime hover:text-lime hover:bg-[hsl(var(--lime)/0.06)] " +
    "active:bg-lime active:text-white active:scale-95 " +
    "transition-all duration-150";

  return (
    <div className="w-full" data-testid="pin-pad">
      <div className="mb-6 flex items-center justify-center gap-3">{dots}</div>
      <div className="grid grid-cols-3 gap-2">
        {keys.map((k) => (
          <button
            key={k}
            type="button"
            data-testid={`pin-key-${k}`}
            onClick={() => press(k)}
            className={keyClass}
          >
            {k}
          </button>
        ))}
        <button
          type="button"
          data-testid="pin-key-clear"
          onClick={() => onChange("")}
          className={
            "h-16 sm:h-[68px] flex items-center justify-center text-[10px] uppercase tracking-[0.2em] font-semibold " +
            "bg-card text-muted-foreground border border-border " +
            "hover:border-destructive hover:text-destructive " +
            "active:scale-95 transition-all duration-150"
          }
        >
          Clear
        </button>
        <button
          type="button"
          data-testid="pin-key-0"
          onClick={() => press("0")}
          className={keyClass}
        >
          0
        </button>
        <button
          type="button"
          data-testid="pin-key-backspace"
          onClick={back}
          className={
            "h-16 sm:h-[68px] flex items-center justify-center text-muted-foreground " +
            "bg-card border border-border " +
            "hover:border-lime hover:text-lime active:scale-95 transition-all duration-150"
          }
        >
          <Delete className="h-5 w-5" strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
